import Vue from 'vue'
import axios from "axios";

export const global = new Vue({
    data: {
        organization_id: null,
        inbox: null,
        approved: null,
        declined: null,
        pages: null,
        contests: null,
        userOrganizations: []
    },
    computed: {
        organization: {
            get: function () { return this.$globals.organization_id },
            set: function (newId) { this.$globals.organization_id = newId; this.$globals.updateRepos(); }
        }
    },
    methods: {
        updateRepos() {
            this.$globals.getDemos();
            this.$globals.getPages();
            this.$globals.getContests();
        },
        getDemos() {
            var self = this;
            console.log("[Globals] Demo's ophalen voor: " + this.$globals.organization_id);
            axios
                .get(
                    "https://api.demobottle.com/demo?status=open&organization_id=" +
                    this.$globals.organization_id
                )
                .then((res) => {
                    self.inbox = null;
                    self.Loading = false;
                    self.inbox = res.data.reverse();
                    console.log(self.inbox);
                })
                .catch((error) => {
                    self.Loading = false;
                    console.error(error);
                });
            axios
                .get(
                    "https://api.demobottle.com/demo?status=approved&organization_id=" +
                    this.$globals.organization_id
                )
                .then((res) => {
                    self.approved = null;
                    self.Loading = false;
                    self.approved = res.data.reverse();
                    console.log(self.approved);
                })
                .catch((error) => {
                    self.Loading = false;
                    console.error(error);
                });
            axios
                .get(
                    "https://api.demobottle.com/demo?status=removed&organization_id=" +
                    this.$globals.organization_id
                )
                .then((res) => {
                    self.declined = null;
                    self.Loading = false;
                    self.declined = res.data.reverse();
                    console.log(self.declined);
                })
                .catch((error) => {
                    self.Loading = false;
                    console.error(error);
                });
        },
        getPages() {
            var self = this;
            console.log("[Globals] pages ophalen voor: " + this.$globals.organization_id);
            axios({
                method: "GET",
                crossdomain: true,
                headers: { "Content-Type": "Content-Type:application/json" },
                url:
                    "https://api.demobottle.com/demo/page?organization_id=" +
                    this.$globals.organization_id
            })
                .then(function (response) {
                    self.pages = response.data;
                })
                .catch(function (error) {
                    self.errors = error.response.data;
                    self.isLoading = false;
                });
        },
        getContests() {
            var self = this;
            console.log("[Globals] contests ophalen voor: " + this.$globals.organization_id);
            axios({
                method: "GET",
                crossdomain: true,
                headers: { "Content-Type": "Content-Type:application/json" },
                url:
                    "https://api.demobottle.com/contest?organization_id=" +
                    this.$globals.organization_id
            })
                .then(function (response) {
                    self.contests = response.data;
                })
                .catch(function (error) {
                    self.errors = error.response.data;
                    self.isLoading = false;
                });
        }
    }
})
